var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"json-editor-container"},[_c('json-editor',{attrs:{"options":_vm.editorOptions},on:{"error":_vm.handleError},model:{value:(_vm.jsonData),callback:function ($$v) {_vm.jsonData=$$v},expression:"jsonData"}}),(_vm.errorMessage)?_c('div',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }